import Footer from './Footer';
import conferenceImage from '../assets/conferencee1.webp'; // Ensure you have the correct path for your image

export default function OHSConferences() {
  return (
    <div className='md:mt-[10px] mt-[100px]'>
      <img
        src={conferenceImage}
        alt="Conference Image"
        className="w-full h-[200px] md:h-[500px] object-cover"
      />

      <div className="bg-white p-12 text-center bg-inspiration-geometry">
        <h2 className="text-4xl font-maiandra mb-4">Promoting a Culture of Workplace Safety</h2>
        <p className="text-gray-700 lg:ml-[33%] md:ml-[15%] font-myraid max-w-lg">
      <b> Mission: </b> To establish a platform where policymakers, industry experts, and practitioners can share best practices, innovations, and strategies to advance occupational health and safety standards in Rwanda and across East Africa.        </p>

        <br></br><br></br><br></br><br></br>

        <h2 className="text-4xl font-maiandra mb-4">What We Do</h2> 
        <br></br>
        <ul className="list-none pl-0 md:pl-32 mb-6 text-left lg:text-center text-gray-900 space-y-1">
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>rganize the Annual Occupational Health and Safety Conference, gathering experts and professionals to discuss key OHS issues, innovations, and policies.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Curate workshops, seminars, and training sessions designed to raise awareness and equip industries with the tools to improve workplace safety.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Facilitate discussions on emerging OHS challenges such as industrial automation, environmental sustainability, and psychological health in workplaces.</li>
        </ul>

        <br></br><br></br><br></br><br></br>

        <div className="p-1 md:p-8">
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-900 p-6 text-white rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra mb-4">Best Practices</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Benchmarking against global OHS events like the American Society of Safety Professionals (ASSP) conferences and the European HSE Summit.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Collaborating with international OHS bodies to ensure cutting-edge content and knowledge sharing.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Encouraging active participation from both private and public sectors for comprehensive safety solutions.</li>
              </ul>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra text-white mb-4">Key Strengths</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>A unique forum addressing Rwanda's specific OHS challenges while incorporating international best practices.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Strong partnerships with industry experts, government authorities, and thought leaders.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Promoting cross-sectoral collaboration to foster a national culture of safety.</li>
              </ul>
            </div>
          </div>
          <br></br><br></br>
        </div>
      </div>

      <Footer />
    </div>
  );
}
